<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="
			modelId > 0
				? $t('saleChannel.edit')
				: $t('saleChannel.new')
		"
	>
		<b-card no-body>
			<b-tabs no-fade pills card small :vertical="vertical" nav-class="nav-style">
				<b-tab title="General" active>
					<b-overlay :show="loading" no-wrap></b-overlay>
					<b-form @submit="onSubmit">
						<FormGroupBox :title="$t('transportUnits.info')">
							<b-form-row>
								<b-form-group
									class="col-lg-4 col-12"
									:label="$t('saleChannel.name')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.name"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-lg-4 col-12"
									:label="$t('saleChannel.code')"
								>
									<b-form-input
										type="text"
										size="sm"
										v-model="modelInfo.code"
										required
									/>
								</b-form-group>
								<b-form-group
									class="col-lg-4 col-12"
									:label="$t('global.status')"
								>
									<b-form-select
										size="sm"
										v-model="modelInfo.status"
										:options="statusOptions"
									></b-form-select>
								</b-form-group>
							</b-form-row>
							<b-form-row>
								<b-form-group
									class="col-12"
									:label="$t('global.description')"
								>
									<b-textarea
										type="text"
										size="sm"
										v-model="modelInfo.description"
									/>
								</b-form-group>
							</b-form-row>
						</FormGroupBox>
						<hr />
						<div class="text-right">
							<b-button variant="primary" type="submit">{{
								modelId > 0
									? $t("global.update")
									: $t("global.save")
							}}</b-button>
						</div>
					</b-form>
				</b-tab>
			</b-tabs>
		</b-card>
	</b-modal>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox.vue";
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: { FormGroupBox },
	data() {
		let defaultModelInfo = {
			id: -1,
			name: "",
			code: "",
			description: "",
			status: "active"
		};
		return {
			modelId: -1,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			loading: true
		};
	},
	computed: {
		statusOptions: function() {
			const optios = [];
			const elm = this.$t("statusActive");
			Object.keys(elm).forEach(item => {
				optios.push({ value: item, text: elm[item] });
			});
			return optios;
		}
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/sales-channels/${this.modelId}`
						: "/sales-channels",
				method: this.modelId > 0 ? "put" : "post"
			};

			rParams["data"] = this.modelInfo;
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert(
						rParams.method == "post"
							? this.$t("global.doneSuccessfully")
							: this.$t("global.doneSuccessfully")
					);
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/sales-channels/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch((err)=>{
						this.$root.handleRequestError(err)
						this.$refs["modal-view"].hide();

					});
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		}
	},
	mounted() {
		console.log("mounted single");
	}
};
</script>

<style></style>
